import React from 'react';
import ThemeButton from 'DesignSystem/Buttons/ThemeButton/ThemeButton';
import { usePublishProductContext } from 'FeatureModules/ProductPage/Contexts/PublishProductContext';

const PublishButton = ({ ...rest }) => {
  const { handleClickPublish } = usePublishProductContext();

  return (
    <ThemeButton onClick={handleClickPublish} color="PRIMARY" size="large" {...rest}>
      Publish product
    </ThemeButton>
  );
};

export default PublishButton;
